// extracted by mini-css-extract-plugin
export default {"wrapper":"fa","quote":"ga","footer":"ha","cite":"ia","citeName":"ja","citeCompany":"ka","blinking":"la"};